import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../app-config';
import { IUserRepository } from './Iuser.repository';
import { ApiResponse, UserProfile } from './models';


@Injectable({ providedIn: 'root' })
export class UserRepository implements IUserRepository {

	private readonly httpClient = inject(HttpClient);
	private readonly config = inject(APP_CONFIG);

	getUserProfile(): Observable<ApiResponse<UserProfile>> {
		return this.httpClient.get<ApiResponse<UserProfile>>(this.config.domainUserAPI + '/api/users/GetUserProfile');
	}
	getApplicationUrl(): Observable<ApiResponse<string>> {
		return this.httpClient.get<ApiResponse<string>>(this.config.domainUserAPI + '/api/users/ApplicationUrl');
	}
}
